<template>
	<label class="SliderCheckbox">
		<input
			type="checkbox"
			class="c_checkbox"
			:checked="checked || modelValue"
			v-bind="$attrs"
			@change="(event) => emit('update:modelValue', (event.target as HTMLInputElement).checked)"
		/>
		<div class="slider"></div>
	</label>
</template>

<script setup lang="ts">
defineOptions({
	inheritAttrs: false,
});
defineProps<{
	modelValue?: string[] | boolean;
	checked?: boolean;
}>();
const emit = defineEmits(['update:modelValue']);
</script>

<style scoped lang="scss">
.SliderCheckbox {
	position: relative;
	display: block;
	width: 5.2rem;
	height: 2.8rem;
	cursor: pointer;
	input {
		display: none;
	}
	.slider {
		width: 100%;
		height: 100%;
		background-color: var(--color-base-light);
		border-radius: var(--border-radius-full);
		transition-property: background-color;
		transition-duration: var(--transition-default);
		border: none;
		&:before {
			content: '';
			position: absolute;
			height: 2.2rem;
			width: 2.2rem;
			top: 0.3rem;
			left: 0.3rem;
			background-color: var(--color-base-white);
			border-radius: 50%;
			transition-property: background-color, transform, width, height, top, left;
			transition-duration: var(--transition-default);
		}
	}
	input:checked + .slider {
		background-color: var(--color-primary);
	}
	input:checked + .slider:before {
		height: 2.2rem;
		width: 2.2rem;
		top: 0.25rem;
		left: 0.7rem;
		transform: translateX(2rem);
		background-color: white;
	}
}
</style>
